import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";
import InfoCardDialog from "@/ui/dialogs/InfoCardDialog";
import CodeExample from "@/components/CodeExample/CodeExample";
import { WEBSHARE_PROXY_DNS_ADDRESS } from "@/config/constants";

type Props = {
  open: boolean;
  onClose: () => void;
  proxyUserName: string;
  password: string;
  planId: string | number;
};

export default function QuickStartOnboardingDialog({
  open,
  onClose,
  proxyUserName,
  password,
  planId,
}: Props) {
  const navigate = useNavigate();

  const handleGoToProxyList = () => {
    onClose();
    void navigate({
      to: "/$planId/proxy/list",
      params: { planId: String(planId) },
    });
  };

  return (
    <InfoCardDialog
      open={open}
      onClose={onClose}
      imageSrc="/proxy_request"
      imageAlt="Quick Start"
      title="Send your first proxy request"
      description="Copy the request below and run it in your terminal to verify your connection."
      actions={
        <>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            Configure locations and connection settings in Proxy List.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleGoToProxyList}
            data-testid="quick-start-go-to-proxy-list"
          >
            Go To Proxy List
          </Button>
        </>
      }
    >
      <Box sx={{ width: "100%", textAlign: "left" }}>
        <CodeExample
          authenticationMethod="username"
          protocol="http"
          proxyUserName={proxyUserName}
          password={password}
          domainName={WEBSHARE_PROXY_DNS_ADDRESS}
          port="80"
          theme="dark"
          onboarding={true}
        />
      </Box>
    </InfoCardDialog>
  );
}
